import { z } from "zod";

/**
 * Slack Setup Response Schema
 *
 * Returns the URL for creating a Slack app from a deployment manifest.
 * This URL can be opened in a browser to create the Slack app.
 */
export const SlackSetupResponseSchema = z.object({
  setupUrl: z.string().url(),
  pendingConnectionId: z.string().uuid()
});

export type SlackSetupResponse = z.infer<typeof SlackSetupResponseSchema>;

/**
 * Get Slack Setup Path Variables Schema
 */
export const GetSlackSetupPathVarsSchema = z.object({
  id: z.string().uuid()
});

export type GetSlackSetupPathVars = z.infer<typeof GetSlackSetupPathVarsSchema>;
